(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("VirtualFairExposController", VirtualFairExposController);

        VirtualFairExposController.$inject = ["VirtualFairService", "InvoicesService", "virtualfair", "toastr", "$state"];

    function VirtualFairExposController(VirtualFairService, InvoicesService, virtualfair, toastr, $state) {

        var vm = this;

        //@TODO: Move the list logic from virtualFairPavilions.controller to this list controller


        async function activate() {

        }

        activate();
    }
})();